import { IconButton, Pagination } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { DataGrid, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { getPermissionData, getUserData } from "../../Actions/common";
import { getAllBlockedIpsAction, deleteBlockedIpAction } from "../../Actions/IpBlockedAction";
import { DataGrid_SX } from "../../Assets/customTheme/constants";
import { CustomNoRowsOverlay } from "../../Assets/customTheme/CustomNoRowsOverlay";
import CustomTooltip from "../../Assets/customTheme/customtooltip";
import {
    MyDeleteOutlineOutlinedIcon,
    MySearchIcon,
} from "../../Assets/svg/MyIcons";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { ITEMS_PER_PAGE_OPTIONS } from "../../config";
import CustomSnackbar from "../Common/snackBar";
import showConfirmation from "../../utils/Conformation";
import { CommonTooltip } from "../../utils/tooltip";

const CustomToolbar = ({
    searchValue,
    handleSearchApi,
    handleFilterData,
    handleResetFilters,
    filterButtonDisabled,
    resetButtonDisabled,
}) => {
    return (
        <div className="custom-header">
            <div className="card border-rounded-0 fiter-card">
                <div className="card-body p-5 pb-0">
                    <div className="row">
                        <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-4 col-sm-6 mb-5">
                            <div className="input-group w-100">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">
                                        <MySearchIcon />
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search IP"
                                    name="search"
                                    value={searchValue}
                                    onChange={handleSearchApi}
                                />
                            </div>
                        </div>
                        <div className="col-auto ms-auto d-flex flex-wrap gap-3 mb-5">
                            <CustomTooltip title="Filter" placement="top" arrow>
                                <span>
                                    <button
                                        className="btn text-primary btn-light btn-icon"
                                        onClick={handleFilterData}
                                        disabled={filterButtonDisabled}
                                    >
                                        <TableFilte />
                                    </button>
                                </span>
                            </CustomTooltip>
                            <CustomTooltip title="Reset" placement="top" arrow>
                                <span>
                                    <button
                                        className="btn text-primary btn-light btn-icon"
                                        onClick={handleResetFilters}
                                        disabled={resetButtonDisabled}
                                    >
                                        <TableReset />
                                    </button>
                                </span>
                            </CustomTooltip>
                            <CustomTooltip title="Column Filter" placement="top" arrow>
                                <span style={{ display: "inline-block" }}>
                                    <GridToolbarColumnsButton
                                        slotProps={{
                                            tooltip: { title: "" },
                                            button: {
                                                className:
                                                    "btn btn-light text-primary btn-icon grid-toolbar d-flex justify-content-center align-items-center p-0",
                                                style: {
                                                    width: "47px",
                                                    height: "44px",
                                                    minWidth: "unset",
                                                    borderRadius: "8px",
                                                },
                                                startIcon: <TableColumns />,
                                            },
                                        }}
                                    />
                                </span>
                            </CustomTooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const IpBlockedListSection = () => {
    const [blockedIpsData, setBlockedIpsData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchValue, setSearchValue] = useState("");
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [shouldFetchData, setShouldFetchData] = useState(1);
    const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
    const [resetButtonDisabled, setResetButtonDisabled] = useState(true);
    const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(ITEMS_PER_PAGE_OPTIONS[0]);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    // Permission check
    const userData = localStorage.getItem("userData") ? getUserData() : null;
    const permissionData = localStorage.getItem(`${userData?.id}_permissionData`)
        ? getPermissionData(`${userData?.id}_permissionData`)
        : [];
    const hasPermission = permissionData[0]?.role_permissions?.find(
        (m) => m?.module && m?.module?.slug === "ip-blocked"
    );

    const getBlockedIps = useCallback(async () => {
        setLoading(true);
        await getAllBlockedIpsAction(currentPage, searchValue, selectedRowsPerPage)
            .then((res) => {
                // console.log(res.data,"sdfsduifgsjgfsjhkg")
                const { rows, count } = res.data;
                setBlockedIpsData(rows);
                setTotalRecords(count);
            })
            .catch((error) => {
                setSnackbar({
                    open: true,
                    message: error?.response?.data?.message || "Something went wrong",
                    severity: "error",
                });
            })
            .finally(() => setLoading(false));
    }, [currentPage, searchValue, selectedRowsPerPage]);

    useEffect(() => {
        if (shouldFetchData) {
            getBlockedIps();
            setShouldFetchData(0);
        }
    }, [shouldFetchData, getBlockedIps]);

    const handleCloseSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));

    const handleDelete = async (e, id) => {
        e.stopPropagation();
        await showConfirmation("simpleDelete", {
            entityName: "Blocked IP",
            entityId: id,
            action: deleteBlockedIpAction,
            onSuccess: () => {
                setSnackbar({
                    open: true,
                    message: "Blocked IP deleted successfully.",
                    severity: "success",
                });
                getBlockedIps();
            },
            onError: (error) => {
                setSnackbar({
                    open: true,
                    message: error?.response?.data?.message || "Something went wrong",
                    severity: "error",
                });
            },
            showCancelledMsg: true,
        });
    };

    const handleSearchApi = (e) => {
        const val = e.target.value.trim();
        setSearchValue(val);
        setFilterButtonDisabled(val.length === 0);
    };

    const handleFilterData = () => {
        setCurrentPage(1);
        setShouldFetchData(1);
        setFilterButtonDisabled(true);
        setResetButtonDisabled(false);
    };

    const handleResetFilters = () => {
        setSearchValue("");
        setCurrentPage(1);
        setShouldFetchData(1);
        setFilterButtonDisabled(true);
        setResetButtonDisabled(true);
    };

    const handlePaginationChange = (event, value) => {
        setCurrentPage(value);
        setShouldFetchData(1);
    };

    const handleRowsPerPageChange = (event) => {
        setBlockedIpsData([]);
        setSelectedRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1);
        setShouldFetchData(1);
    };

    const columns = [
        {
            field: "ipAddress",
            headerName: "IP Address",
            minWidth: 180,
            flex: 1,
        },
        {
            field: "attempts",
            headerName: "Failed Attempts",
            minWidth: 160,
            flex: 1,
            renderCell: (params) => (
                <span className="fw-bold text-danger">
                    {params.row.attempts}
                    {/* {params.row.maxAttempts ? ` / ${params.row.maxAttempts}` : ""} */}
                </span>
            ),
        },
        {
            field: "remainingAttempts",
            headerName: "Remaining Attempts",
            minWidth: 180,
            flex: 1,
            renderCell: (params) => {
                const remaining = params.row.remainingAttempts ?? "—";
                const isBlocked = params.row.isActive;
                return (
                    <span className={`fw-bold ${isBlocked ? "text-danger" : "text-success"}`}>
                        {isBlocked ? "0" : remaining}
                    </span>
                );
            },
        },
        {
            field: "lastFailedDateTime",
            headerName: "Last Failed At",
            minWidth: 200,
            flex: 1,
            renderCell: (params) =>
                params.row.lastFailedDateTime
                    ? new Date(params.row.lastFailedDateTime).toLocaleString()
                    : "—",
        },
        {
            field: "isActive",
            headerName: "Status",
            minWidth: 130,
            flex: 1,
            renderCell: (params) => (
                <span
                    className={`badge ${
                        params.row.isActive ? "badge-light-danger" : "badge-light-success"
                    }`}
                >
                    {params.row.isActive ? "Blocked" : "Active"}
                </span>
            ),
        },
        // Action column shown only if user has canDelete permission
        ...(hasPermission?.canDelete
            ? [
                  {
                      field: "actions",
                      headerName: "Action",
                      sortable: false,
                      minWidth: 100,
                      renderCell: (params) => (
                          <CommonTooltip title="Delete" placement="top" arrow>
                              <IconButton
                                  className="btn-custom-i text-danger"
                                  onClick={(e) => handleDelete(e, params.row.id)}
                              >
                                  <MyDeleteOutlineOutlinedIcon />
                              </IconButton>
                          </CommonTooltip>
                      ),
                  },
              ]
            : []),
    ];

    return (
        <div id="kt_content_container">
            <BreadcrumbsComponent />

            <DataGrid
                className="border-0"
                localeText={{ toolbarColumns: "" }}
                rows={blockedIpsData}
                columns={columns}
                autoHeight
                hideFooterRowCount={true}
                hideFooterPagination={true}
                hideFooter={true}
                loading={loading}
                slots={{
                    toolbar: CustomToolbar,
                    noRowsOverlay: CustomNoRowsOverlay,
                }}
                slotProps={{
                    toolbar: {
                        searchValue,
                        handleSearchApi,
                        handleFilterData,
                        handleResetFilters,
                        filterButtonDisabled,
                        resetButtonDisabled,
                    },
                }}
                sx={DataGrid_SX}
            />

            <div className="card-footer d-flex align-items-center justify-content-between mt-7">
                <div className="d-flex align-items-center">
                    <label className="fw-semibold me-3">Row per page</label>
                    <FormControl variant="standard" style={{ minWidth: 50 }}>
                        <Select
                            value={selectedRowsPerPage}
                            onChange={handleRowsPerPageChange}
                            label="Row per page"
                        >
                            {ITEMS_PER_PAGE_OPTIONS?.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                {!loading && blockedIpsData?.length > 0 && (
                    <Pagination
                        count={Math.ceil(totalRecords / selectedRowsPerPage)}
                        page={currentPage}
                        onChange={(event, value) =>
                            value !== currentPage
                                ? handlePaginationChange(event, value)
                                : null
                        }
                        variant="outlined"
                        shape="rounded"
                        className="custom-pagination"
                    />
                )}
            </div>

            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={handleCloseSnackbar}
            />
        </div>
    );
};

export default IpBlockedListSection;
